import { ArrowUpRight, Languages } from "lucide-react";
import { Link } from "react-router-dom";
import { languageLabels } from "../data/categories";
import type { ProjectWording } from "../types";
import { CopyButton } from "./CopyButton";
import { StatusBadge } from "./StatusBadge";
import { WarningCallout } from "./WarningCallout";

export function WordingCard({ wording }: { wording: ProjectWording }) {
  return (
    <article className="wording-card">
      <div className="wording-card__header">
        <span><Languages size={15} aria-hidden="true" />{languageLabels[wording.language]}</span>
        <StatusBadge status={wording.status} />
      </div>
      <h2>{wording.title}</h2>
      <blockquote>{wording.text}</blockquote>
      <dl className="inline-meta">
        <div><dt>Аудитория</dt><dd>{wording.audience}</dd></div>
        <div><dt>Где использовать</dt><dd>{wording.usageNote ?? "Без дополнительных ограничений"}</dd></div>
      </dl>
      {wording.status !== "approved" && (
        <WarningCallout title={wording.status === "draft" ? "Черновик" : "Нужна проверка"}>
          Проверьте формулировку перед использованием во внешних материалах.
        </WarningCallout>
      )}
      <div className="card-actions">
        <CopyButton text={wording.text} />
        <Link className="button button--ghost" to={`/wording/${wording.id}`}>
          Подробнее <ArrowUpRight size={17} aria-hidden="true" />
        </Link>
      </div>
    </article>
  );
}
